export function safeAnalyticsUrl(value) {
  if (!value) return "";
  try {
    const url = new URL(value, window.location.origin);
    const path = url.pathname.replace(/^\/shop\/order\/[^/]+/, "/shop/order").replace(/^\/staff\/.*$/, "/staff");
    return url.origin + path;
  } catch { return ""; }
}

export function safeEventParams(values = {}) {
  const out = {};
  for (const [key, value] of Object.entries(values)) {
    if (/email|phone|address|password|token|session_id|message|search_term|contact|customer|user_id/i.test(key)) continue;
    if (/url|location|referrer/i.test(key)) { out[key] = safeAnalyticsUrl(value); continue; }
    if (typeof value === "string") { if (!/@|\b\d{3}[- .]?\d{3}[- .]?\d{4}\b/.test(value)) out[key] = value.slice(0, 200); }
    else if (typeof value === "boolean" || typeof value === "number" && Number.isFinite(value)) out[key] = value;
  }
  return out;
}

let lastPath = "";
export function trackPage(path) {
  if (lastPath === path) return;
  lastPath = path;
  if (/^\/staff(\/|$)/.test(path)) return;
  const url = safeAnalyticsUrl(window.location.origin + path);
  const properties = { page_location: url, page_referrer: safeAnalyticsUrl(document.referrer), page_title: document.title };
  try {
    if (typeof window.gtag === "function") { window.gtag("set", properties); window.gtag("event", "page_view", properties); }
    if (typeof window.posthog?.capture === "function") window.posthog.capture("$pageview", { $current_url: url, $pathname: new URL(url).pathname });
    if (typeof window.posthog?.stopSessionRecording === "function") window.posthog.stopSessionRecording();
  } catch { /* Analytics must never break a page or conversation. */ }
}